<template>
    <div class="contact-card" :class="{'contact-card__grid': result.type === 'wide'}">
        <a :href="result.detailPage" class="contact-card__image">
            <img v-if="result.detailPicture" :src="result.detailPicture.src" :alt="result.detailPicture.alt" >
            <img v-else-if="result.picture" :src="result.picture.src" :alt="result.picture.alt">
        </a>
        <div class="contact-card__content">
            <div class="contact-card__header">
                <span v-if="result.date" class="contact-card__date">{{result.date}}</span>
                <a v-if="result.name" :href="result.detailPage" class="def-title-3">{{result.name}}</a>
            </div>
            <div class="contact-card__bottom">
            <span>
                <p class="contact-card__name">{{ result.namePersone }}</p>
                <p class="contact-card__position">{{ result.position }}</p>
            </span>
                <span>
                <a :href="getPhone" class="contact-card__phone"><p>{{ result.phone }}</p></a>
                <a :href="getEmail" class="contact-card__email"><p>{{ result.email }}</p></a>
            </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "contact-card",
    props:{
        result: {
            type: Object
        },
        messages: {
            type: Object,
        }
    },
    methods: {
        getScreenWidth() {
            return window.innerWidth;
        }
    },
    computed: {
        getPhone() {
            let phone = 'phone:' + this.result.phone;
            return phone
        },
        getEmail() {
            let mailto = 'mailto:' + this.result.email;
            return mailto
        }
    }
}
</script>

<style scoped lang="scss">
    .contact-card{

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px;
        margin-bottom: 4px;
        background: #fff;
        img {
            width: 100%;
        }
        &__header{
            margin-top: 24px;
            width: 100%;
            padding-bottom: 16px;
            text-align: center;
            border-bottom: 1px solid #DFDFDF;
            a{
                letter-spacing: 0.08em;
                font-weight: 500;
                font-size: 18px;
                text-transform: uppercase;

                @include point-md {
                    font-size: 17px;

                }
            }
        }
        &__content{
            width: 100%;
        }
        &__bottom{

            span{
                margin-top: 32px;
                display: block;
                text-align: center;
            }
        }
        &__name{
            letter-spacing: 0.08em;
            font-weight: 500;
            font-size: 18px;
        }
        &__position{
            font-size: 14px;
            color: #757575;
        }
        &__phone{
            font-size: 20px;
            font-weight: bold;
        }
        &__email{
            font-weight: 500;
            font-size: 16px;
        }
        &__grid{
            padding: 0;
            @include point-md {
                grid-column-start: 1;
                grid-column-end: 4;
                grid-row-start: 5;

                flex-direction: row;

                padding: 0;

            }
            .contact-card__content{
                padding: 24px;

                @include point-md {
                    width: 33.3%;
                }

            }
            .contact-card__image{
                display: block;

                @include point-md {
                    width: 66.6%;
                }
                img{
                    display: block;
                }
            }
        }
    }
</style>